import { styled, Grid } from '@material-ui/core'
import { LanguageSelect as BaseLanguageSelect } from 'shared/components'

export const Container = styled(Grid)(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.common.white,
  overflow: 'auto',
}))

export const FormWrapper = styled(Grid)(({ theme }) => ({
  height: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(3.5, 0, 2),
  overflow: 'hidden auto',
  position: 'relative',
  flex: '1 0 auto',
}))

export const SliderWrapper = styled(Grid)({
  height: '100%',
  boxSizing: 'border-box',
})

export const LanguageSelect = styled(BaseLanguageSelect)({
  position: 'absolute',
  right: 0,
})
